<template>
  <div class="container" v-if="entries && entries.length > 0">
    <p class="label">
      <img :src="require('@/assets/icons/book-blue.svg')" />
      {{ $t("general.post.dictionary.added") }}
    </p>

    <div class="subcontainer">
      <p v-for="entry in entries" :key="entry.id" class="entry">
        <span>{{ entry.title }}</span>
        <a href="#" @click.prevent="$emit('entry-deleted', entry.id)">
          <img :src="require('@/assets/icons/close-blue.svg')" height="24" />
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddedDictionaryEntries",
  props: {
    entries: { required: true }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 90%;
  margin: 16px auto;
  padding-left: 16px;
  padding-right: 16px;
  text-align: left;
  border-left: 1px solid rgb(49, 185, 190);
}

.label {
  margin-bottom: 8px;

  img {
    max-width: 24px;
    max-height: 24px;
    vertical-align: middle;
  }
}

.dictionarylist {
  width: 100%;
  border: 0;
}

.entry {
  margin: 0;
  height: 24px;
  line-height: 24px;

  a {
    float: right;
    vertical-align: middle;
    height: 24px;

    img {
      height: 24px;
    }
  }
}
</style>
